(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    /* Localize any HTTP nav links that still point to the shop's primary domain */
  document.addEventListener('DOMContentLoaded', function() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root === '/') return; /* default market, nothing to fix */
    document.querySelectorAll('.menu-drawer a[href*="heyscent.co/"], .menu-list a[href*="heyscent.co/"]').forEach(function(a) {
      try {
        var u = new URL(a.href);
        a.href = root + u.pathname.substring(1) + u.search + u.hash;
      } catch(e) {}
    });
  });
  } catch(e) { console.error(e); }
})();

})();
